import React from 'react';
import ServiceItem from '../ServiceItem';
import classes from './RenderServicePills.module.css';
import clsx from 'clsx';
const RenderServicePills = ({ data }) => {
  if (!Array?.isArray(data)) return data;
  let result = data;
  // if (data?.length > 3) result = data.slice(0, 3);
  return (
    <span className={clsx(classes.wrapper, 'scrollbar1')}>
      {result?.map((data) => (
        <ServiceItem
          key={data}
          className={classes.serviceItem}
          label={`${data?.serviceName} ${data?.serviceId === null ? '' : 'X' + data?.quantity}`}
        />
      ))}
    </span>
  );
  // `(Rs.${data?.serviceFees})`
};

export default RenderServicePills;
